/**
 * Converts an emoji character to a PNG image URL.
 *
 * Files are named using the Twemoji convention: strip U+FE0F variation selectors,
 * join remaining codepoints with '-', append '.png'.
 * e.g. 🐱 → "1f431.png", ☀️ → "2600.png"
 *
 * CDN_BASE controls where images are loaded from:
 *   - Development / fallback: jsDelivr Twemoji CDN
 *   - Production: Worker /images route serving R2-hosted generated PNGs
 *
 * To switch to generated images after running scripts/generate-images.mjs:
 *   Change CDN_BASE to 'https://kids-puzzle-worker.<your-subdomain>.workers.dev/images'
 *   Find your subdomain at: dash.cloudflare.com → Workers & Pages → kids-puzzle-worker
 */

// ── Change this one line to switch from Twemoji to your generated R2 images ──
const CDN_BASE = 'https://kids-puzzle-worker.p-znuderl.workers.dev/images'

const VARIATION_SELECTOR = 0xFE0F  // "emoji presentation" selector — not part of the glyph

/**
 * Returns a PNG URL for the given emoji.
 * Works for single-codepoint emoji, emoji with variation selectors, and
 * ZWJ sequences (e.g. family emoji), but the rebus bank only uses simple ones.
 */
export function emojiUrl(emoji: string): string {
  const parts: string[] = []
  let i = 0
  while (i < emoji.length) {
    const code = emoji.codePointAt(i)!
    if (code !== VARIATION_SELECTOR) {
      parts.push(code.toString(16))
    }
    // Astral-plane codepoints (> U+FFFF) are encoded as surrogate pairs → 2 JS chars
    i += code > 0xFFFF ? 2 : 1
  }
  return `${CDN_BASE}/${parts.join('-')}.png`
}
